import request from '@/assets/util/request'   //ajax请求

export const companyList = (data)=> {
    return request({
        url: `/agent/api/company/list`,
        method: 'post',
        data: data,
        params:data
    })
}

export const companyAndStore = (data)=> {
    return request({
        url: `/agent/api/companyAndStore/list`,
        method: 'post',
        data: data,
        params:data
    })
}



export const companyDetail = (data)=> {
    return request({
        url: `/agent/api/company/${data.id}`,
        method: 'get',
        params:data
    })
}

export const behavior = (data)=> {
    return request({
        url: `/agent/api/company/behavior/list`,
        method: 'post',
        params:data,
        data: data,
    })
}


export const signList = (data)=> {
    return request({
        url: `/agent/api/company/sign/list`,
        method: 'post',
        params:data,
        data: data,
    })
}


